import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/auth/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/auth/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'home',
    loadChildren: () => 
    import('./pages/home/home.module').then( m => m.HomePageModule)//,canActivate: [AuthGuard]
  },
  {
    path: 'ivgrid',
    loadChildren: () => import('./pages/ivgrid/ivgrid.module').then( m => m.IvgridPageModule)//,canActivate: [AuthGuard]
  },
  {
    path: 'table',
    loadChildren: () => import('./pages/table/table.module').then( m => m.TablePageModule)//,canActivate: [AuthGuard]
  },
  {
    path: 'ivform',
    loadChildren: () => import('./pages/ivform/ivform.module').then( m => m.IvformPageModule)//,canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
